import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
import IconButton from "components/common/IconButton";
const StyledLabel = styled(Label)`
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-block;
`;
const PaginatedTeamItem = ({ team, onDeleteItem = void 0, roles }) => {
  const { t } = useTranslation("enterprise_security");
  const deleteButton = typeof onDeleteItem === "function" ? /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick: () => onDeleteItem(team),
      name: "close",
      title: t("paginated_team_item.remove", { name: team.name })
    }
  ) : null;
  return /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, team.name), /* @__PURE__ */ React.createElement("td", null, team.description), /* @__PURE__ */ React.createElement("td", null, roles.map((role) => /* @__PURE__ */ React.createElement(StyledLabel, { key: role.id }, role.name))), deleteButton ? /* @__PURE__ */ React.createElement("td", null, deleteButton) : /* @__PURE__ */ React.createElement("td", null)));
};
export default PaginatedTeamItem;
